import ArticleCard from 'components/ArticleCard';
import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import Heading from 'components/text/Heading';
import PropTypes from 'prop-types';
import React from 'react';
import TextLink from 'components/text/TextLink';
import styled from 'libs/styled';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

const HeadingWrapper = styled('div')`
    display: flex;
    align-items: flex-end;
`;

const ArticleFlow = ({ heading, headingTag = 'h2', articles = [], link }) => {
    const isAboveSm = useAboveBreakpoint('sm');

    return (
        <>
            <HeadingWrapper mb={['32px', null, null, '56px']}>
                {heading && (
                    <Heading as={headingTag} size="lg">
                        {heading}
                    </Heading>
                )}
                {link && (
                    <TextLink
                        fontSize="1.8rem"
                        lineHeight="1.2 !important"
                        mb={['4px', null, '8px']}
                        ml="auto"
                        to={link.to}
                    >
                        {link.label}
                    </TextLink>
                )}
            </HeadingWrapper>
            <ColumnsLayout
                blocks={articles.map(article => (
                    <ArticleCard
                        image={isAboveSm ? article.backgroundLandscape : article.backgroundPortrait}
                        key={article.id}
                        {...article}
                    />
                ))}
                columnSizes={[12, null, 4]}
                gutterHeight={32}
                gutterWidth={[0, null, 12, 24]}
                style={{ alignItems: 'flex-end' }}
            />
        </>
    );
};

ArticleFlow.propTypes = {
    articles: PropTypes.arrayOf(PropTypes.object).isRequired,
    heading: PropTypes.string,
    headingTag: PropTypes.string,
    link: PropTypes.shape({
        label: PropTypes.string,
        to: PropTypes.string,
    }),
    tag: PropTypes.string,
    text: wysiwygProp,
};

export default ArticleFlow;
